import React from 'react';

/*
    - components
*/
import ExtraPassengerComponent from './request-manager/extraPassenger';
import HalfChargeComponent from './request-manager/halfCharge';
import HotelInfoComponent from './request-manager/hotelInfo';
import ModifyDateComponent from './request-manager/modifyDate';
import ModifyPassengerComponent from './request-manager/modifyPassenger';
import ModifyRoomComponent from './request-manager/modifyRoom';
import TransferComponent from './request-manager/transfer';

const RequestManager = ({ reserveRoomsResult, activeRoomsResult, maxExtraPersonCountResult, earlyCheckInOutResult, hasFreeTransferResult, airplanCompaniesResult, trainLinesResult, requestType, selectedReserve, selectedService, sendRequestStatusProps, modifyRoomProps, modifyDateProps, extraPassengerProps, halfChargeProps, hotelInfoProps, modifyPassengerProps, transferProps }) => {

    /*
        - cancelProgress
    */
    React.useEffect(() => {
        if (selectedService === 'cancel') {
            sendRequestStatusProps(true);
        }
    }, []);

    return (

        <React.Fragment>

            <ModifyRoomComponent
                reserveRoomsResult={reserveRoomsResult}
                activeRoomsResult={activeRoomsResult}
                requestType={requestType}
                sendRequestStatusProps={sendRequestStatusProps}
                modifyRoomProps={modifyRoomProps} />

            <ModifyDateComponent
                requestType={requestType}
                selectedReserve={selectedReserve}
                sendRequestStatusProps={sendRequestStatusProps}
                modifyDateProps={modifyDateProps} />

            <ExtraPassengerComponent
                reserveRoomsResult={reserveRoomsResult}
                maxExtraPersonCountResult={maxExtraPersonCountResult}
                requestType={requestType}
                sendRequestStatusProps={sendRequestStatusProps}
                extraPassengerProps={extraPassengerProps} />

            <HalfChargeComponent
                reserveRoomsResult={reserveRoomsResult}
                earlyCheckInOutResult={earlyCheckInOutResult}
                requestType={requestType}
                halfChargeProps={halfChargeProps}
                sendRequestStatusProps={sendRequestStatusProps} />

            <HotelInfoComponent
                requestType={requestType}
                sendRequestStatusProps={sendRequestStatusProps}
                hotelInfoProps={hotelInfoProps} />

            <ModifyPassengerComponent
                reserveRoomsResult={reserveRoomsResult}
                requestType={requestType}
                sendRequestStatusProps={sendRequestStatusProps}
                modifyPassengerProps={modifyPassengerProps} />

            <TransferComponent
                hasFreeTransferResult={hasFreeTransferResult}
                airplanCompaniesResult={airplanCompaniesResult}
                trainLinesResult={trainLinesResult}
                requestType={requestType}
                selectedService={selectedService}
                sendRequestStatusProps={sendRequestStatusProps}
                transferProps={transferProps} />

        </React.Fragment>

    );

}

export default RequestManager;